export default "__VITE_ASSET__BbHyFZ9J__"